export const wishlistToken = 'wishlistToken';

export interface Wishlist {
    id: string;
    variantIds: string[];
}

export const defaultWishlist = {
    id: '',
    variantIds: [],
};
